<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 12C13.5 7.8579 11.1264 4.30404 7.66912 2.59238C8.10249 2.53142 8.54606 2.5 9 2.5C10.2476 2.5 11.4829 2.74572 12.6355 3.22314C13.7881 3.70056 14.8354 4.40033 15.7175 5.28249C16.5997 6.16464 17.2994 7.21191 17.7769 8.36451C18.2543 9.5171 18.5 10.7524 18.5 12C18.5 13.2476 18.2543 14.4829 17.7769 15.6355C17.2994 16.7881 16.5997 17.8354 15.7175 18.7175C14.8354 19.5997 13.7881 20.2994 12.6355 20.7769C11.4829 21.2543 10.2476 21.5 9 21.5C8.54606 21.5 8.1025 21.4686 7.66913 21.4076C11.1264 19.696 13.5 16.1421 13.5 12Z"
      stroke="currentColor" />
  </svg>
</template>
